
import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';

const TermosDeUso = () => {
  return (
    <div className="min-h-screen">
      <section className="pt-16 pb-6 bg-gradient-to-b from-blue-50/50 to-transparent">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="max-w-4xl mx-auto"
          >
            <div className="flex items-center gap-3 mb-6 justify-center md:justify-start">
              <div className="bg-blue-light/20 p-2 rounded-full">
                <Shield className="h-6 w-6 text-blue-dark" />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-blue-dark">Termos de Uso</h1>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6 md:p-8 mb-8">
              <p className="text-gray-600 mb-6">
                Última atualização: 01/04/2025
              </p>

              <div className="space-y-6">
                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">1. Aceitação dos Termos</h2>
                  <p className="text-gray-700 mb-3">
                    Ao acessar ou usar o BrokerBase, você concorda em cumprir estes Termos de Uso e todas as leis e regulamentos aplicáveis. Se você não concordar com algum destes termos, está proibido de usar este serviço.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">2. Uso do Serviço</h2>
                  <p className="text-gray-700 mb-3">
                    O BrokerBase oferece ferramentas de análise imobiliária e informações de mercado. Nossos serviços são fornecidos "como estão", sem garantias expressas ou implícitas.
                  </p>
                  <p className="text-gray-700 mb-3">
                    Você concorda em usar o serviço apenas para fins legais e de maneira que não infrinja os direitos de terceiros ou restrinja o uso por outros usuários.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">3. Contas de Usuário</h2>
                  <p className="text-gray-700 mb-3">
                    Ao criar uma conta em nosso serviço, você é responsável por manter a segurança de sua conta e senha. A administração não pode e não será responsável por quaisquer perdas ou danos resultantes de sua falha em cumprir com esta obrigação de segurança.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">4. Propriedade Intelectual</h2>
                  <p className="text-gray-700 mb-3">
                    O serviço e seu conteúdo original, recursos e funcionalidades são e permanecerão propriedade exclusiva do BrokerBase e seus licenciadores. O serviço é protegido por direitos autorais, marcas registradas e outras leis.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">5. Responsabilidade pelas Informações</h2>
                  <p className="text-gray-700 mb-3">
                    As análises e informações fornecidas pelo BrokerBase são baseadas nos dados disponíveis e devem ser usadas apenas como referência. Recomendamos que todas as decisões de investimento imobiliário sejam acompanhadas por profissionais qualificados.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">6. Limitação de Responsabilidade</h2>
                  <p className="text-gray-700 mb-3">
                    Em nenhum caso o BrokerBase, seus diretores, funcionários ou agentes serão responsáveis por quaisquer danos indiretos, consequenciais, exemplares, incidentais, especiais ou punitivos, incluindo perda de lucros, mesmo se informados da possibilidade de tais danos.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">7. Modificações do Serviço</h2>
                  <p className="text-gray-700 mb-3">
                    Reservamo-nos o direito de modificar ou descontinuar, temporária ou permanentemente, o serviço (ou qualquer parte dele) com ou sem aviso prévio.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">8. Alterações nos Termos</h2>
                  <p className="text-gray-700 mb-3">
                    Reservamo-nos o direito de modificar estes termos a qualquer momento. Publicaremos quaisquer alterações em nossa plataforma. É sua responsabilidade verificar periodicamente os termos atualizados.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">9. Lei Aplicável</h2>
                  <p className="text-gray-700 mb-3">
                    Estes termos serão regidos e interpretados de acordo com as leis do Brasil, sem considerar conflitos de disposições legais.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">10. Contato</h2>
                  <p className="text-gray-700 mb-3">
                    Quaisquer perguntas sobre estes Termos de Uso devem ser enviadas para nosso email de contato disponível na plataforma.
                  </p>
                </section>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default TermosDeUso;
